import React, { memo, useMemo } from 'react';
import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { ActivityIndicator, TouchableOpacity, View, } from 'react-native';
import { Typography } from '../typography/Typography';
import { Space } from '../space/Space';
import { Icon } from '../icon/Icon';
import { Divider } from '../divider/Divider';
import { Image } from '../image/Image';
import { UPDATE_REQUEST_TYPE } from '../pages/constants';
const ListItemBase = ({ id, leadIconName, trailIconName, trailLabel, customTitle, customSubTitle, isDarkMode, title, subTitle, isDivider = false, subTitleLineHeight = 0, titleLineHeight = 0, rightIcon = false, handleAsterisk = false, loader, userUpdatedValue, userUpdatedType, userUpdatedMessage, isUserUpdateDetailsInProgress, rightIconClickableAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMap = theme.colors;
    const Clock_filled_url = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Clock_filled.png';
    const getTitle = () => {
        let title = '';
        if (userUpdatedType === UPDATE_REQUEST_TYPE.PHONE_NUMBER) {
            title = `Request to update mobile number to ${userUpdatedValue?.slice(0, 3)} ${userUpdatedValue?.slice(3)} is in progress.`;
        }
        else
            title = `Request to update email ID to ${userUpdatedValue} is in progress.`;
        return title;
    };
    const getSubTitle = () => {
        let title = '';
        if (userUpdatedType === UPDATE_REQUEST_TYPE.PHONE_NUMBER) {
            title = `Can't edit email ID until ongoing request is processed.`;
        }
        else
            title = `Can't edit mobile number until ongoing request is processed.`;
        return title;
    };
    const RenderUpdateMessage = useMemo(() => {
        return (React.createElement(View, { style: { backgroundColor: '#F1F3F5', borderRadius: 8, padding: 12, flexDirection: 'row', alignItems: 'center' } },
            React.createElement(Image, { uri: Clock_filled_url, size: ImageSizeTokens.XXS }),
            React.createElement(View, { style: { marginLeft: 8, flexShrink: 1 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: getTitle(), color: ColorTokens.Grey_Night }))));
    }, [userUpdatedType]);
    const RenderSubUpdateMessage = () => {
        return (React.createElement(View, { style: { marginLeft: 56 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: getSubTitle(), color: ColorTokens.Grey_Charcoal })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Space, { size: SizeTypeTokens.XL }),
        React.createElement(View, { nativeID: id, style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    flex: 1,
                } },
                leadIconName && (React.createElement(React.Fragment, null,
                    React.createElement(View, { style: {
                            borderRadius: 20,
                            width: 40,
                            height: 40,
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: colorMap[ColorTokens.Primary_05],
                        } },
                        React.createElement(Icon, { name: leadIconName, color: ColorTokens.Primary_100, size: IconSizeTokens.XXL })),
                    React.createElement(Space, { size: SizeTypeTokens.XL }))),
                React.createElement(View, { style: {
                        paddingRight: 10,
                        flex: 1,
                    } },
                    customTitle ? (React.createElement(Typography, { ...customTitle })) : (React.createElement(Typography, { label: title, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, fontWeight: '400', lineHeight: titleLineHeight, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal })),
                    React.createElement(Space, { size: SizeTypeTokens.SM }),
                    customSubTitle ? (React.createElement(Typography, { ...customSubTitle })) : subTitle ? (React.createElement(Typography, { label: subTitle, fontFamily: !handleAsterisk && FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: handleAsterisk ? 'normal' : '400', color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Night, lineHeight: subTitleLineHeight })) : (React.createElement(React.Fragment, null))),
                rightIcon && React.createElement(View, null,
                    React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.XXXL, color: ColorTokens.Primary_100 }))),
            trailIconName && rightIconClickableAction ? (React.createElement(TouchableOpacity, { onPress: () => {
                    rightIconClickableAction &&
                        rightIconClickableAction();
                } },
                React.createElement(Icon, { name: trailIconName || IconTokens.Edit, size: IconSizeTokens.SM }))) : trailIconName ? (React.createElement(Icon, { name: trailIconName || IconTokens.Edit, size: IconSizeTokens.SM })) : (React.createElement(React.Fragment, null)),
            loader && (React.createElement(ActivityIndicator, { color: '#1434CB', size: 18 })),
            React.createElement(Space, { size: SizeTypeTokens.XS }),
            trailLabel && React.createElement(Typography, { ...trailLabel })),
        React.createElement(Space, { size: SizeTypeTokens.XL }),
        (isUserUpdateDetailsInProgress && userUpdatedMessage === true) && RenderUpdateMessage,
        (isUserUpdateDetailsInProgress && userUpdatedMessage === false) && React.createElement(RenderSubUpdateMessage, null),
        isUserUpdateDetailsInProgress && React.createElement(Space, { size: SizeTypeTokens.XL }),
        isDivider ? (React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 })) : (React.createElement(React.Fragment, null))));
};
export default memo(ListItemBase);
export { ListItemBase };
